import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchInsert_SessionID, fetchInsert_UsageMetrics, fetchPage_id, fetchUpdate_SessionID, fetchUpdate_UsageMetrics } from "../../redux/slices/user";


const getDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileUA = /mobile|android|iphone|ipod/i.test(userAgent);
    const isTabletUA = /tablet|ipad|android/i.test(userAgent);
    const isSmallScreen = window.innerWidth <= 768;
    const isTouchDevice = navigator.maxTouchPoints > 1;

    if (isMobileUA || (isSmallScreen && isTouchDevice)) return 'Mobile';
    if (isTabletUA) return 'Tablet';
    return 'Desktop';
};

export default function SessionMonitor({ children, includebypages }) {

    // UserMail
    const user_email = useMemo(() => sessionStorage.getItem("userEmailId") ?? "anonymous user", [])

    // Redux Hooks
    const dispatch = useDispatch();

    // React-Router Hooks
    const location = useLocation();

    // Redux States
    const { SessionID, PageID } = useSelector(state => state.user)

    // get Device Type on Load
    const DeviceType = useMemo(() => getDeviceType(), []);

    /* Events */
    // Page Change Event
    const handlePageExit = useCallback(() => {
        if (PageID) {
            dispatch(fetchUpdate_UsageMetrics({
                "filters": [],
                "dynamicColumns": [
                    { "columnName": "#{SESSION_ID}", "columnValue": SessionID },
                    { "columnName": "#{user_id}", "columnValue": user_email },
                    { "columnName": "#{page_id}", "columnValue": PageID },
                    { "columnName": "#{end_time}", "columnValue": new Date().toISOString() },
                ],
            }))
        }
    }, [SessionID, PageID])

    // Session Out Event
    const handleSessionExit = useCallback(() => {
        if (SessionID) {
            dispatch(fetchUpdate_SessionID({
                "filters": [],
                "dynamicColumns": [
                    { "columnName": "#{session_id}", "columnValue": SessionID },
                    { "columnName": "#{user_id}", "columnValue": user_email },
                    { "columnName": "#{end_time}", "columnValue": new Date().toISOString() },
                ],
            }))
        }
    }, [SessionID])
    /*  */

    useEffect(() => {
        if (process.env.REACT_APP_ENV == "development") {
            console.error("Usage is monitored on dev mode due to React Strict Mode");
            return;
        }

        if (!SessionID) {
            dispatch(fetchInsert_SessionID({
                "filters": [],
                "dynamicColumns": [
                    { "columnName": "#{user_id}", "columnValue": user_email },
                    { "columnName": "#{start_time}", "columnValue": new Date().toISOString() },
                    { "columnName": "#{device_type}", "columnValue": DeviceType },
                ],
            }))

            return;
        }


        window.addEventListener('beforeunload', handleSessionExit);

        return () => {
            window.removeEventListener('beforeunload', handleSessionExit);
        };

    }, [SessionID])


    // Handle Monitoring Page Wise

    useEffect(() => {
        if (process.env.REACT_APP_ENV == "development") {
            console.error("Usage is monitored on dev mode due to React Strict Mode");
            return;
        }

        if (includebypages) {
            dispatch(fetchPage_id({
                "filters": [
                    {
                        columnName: "PATH",
                        columnValue: location.pathname,
                        "excludeKeyword": false
                    }
                ],
                "dynamicColumns": [],
            }))
        }
    }, [location.pathname])

    useEffect(() => {
        if (process.env.REACT_APP_ENV == "development") {
            console.error("Usage is monitored on dev mode due to React Strict Mode");
            return;
        }

        if (PageID && SessionID) {
            dispatch(fetchInsert_UsageMetrics({
                "filters": [],
                "dynamicColumns": [
                    { "columnName": "#{session_id}", "columnValue": SessionID },
                    { "columnName": "#{user_id}", "columnValue": user_email },
                    { "columnName": "#{page_id}", "columnValue": PageID },
                    { "columnName": "#{start_time}", "columnValue": new Date().toISOString() },
                    { "columnName": "#{device_type}", "columnValue": DeviceType },
                ],
            }))

            return handlePageExit;
        }
    }, [SessionID, PageID])

    // Handle capture last page when explict closing
    useEffect(() => {

        window.addEventListener('beforeunload', handlePageExit);

        return () => {
            window.removeEventListener('beforeunload', handlePageExit);
        };

    }, [handlePageExit])

    return children ?? null;
}
